import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Trans } from '@lingui/react';
import { PlaylistFavoriting } from '@ecosystems/Favoriting';
import { StyledMaterialButton } from './buttons';
import TextWithIcon from './TextWithIcon';
import Spinner from './Spinner';

const ButtonFavoritePlaylistCard = props => {
  const theme = useContext(ThemeContext);

  const handleFavoriting = async onClickFavoriteHandler => {
    await onClickFavoriteHandler();
  };

  return (
    <PlaylistFavoriting playlistId={props.playlistId}>
      {({ isPlaylistFavoritedById, onClickFavoriteHandler, loading }) => {
        if (loading) {
          return (
            <StyledMaterialButton disabled>
              <Spinner
                style={{ padding: '10px' }}
                size={10}
                spinnerColor={'#7d7d7d'}
              ></Spinner>

              {isPlaylistFavoritedById ? (
                <Trans
                  id="metadata.saved_favorites"
                  message={`Saved to favorites`}
                />
              ) : (
                <Trans
                  id="metadata.save_favorites"
                  message={`Save to favorites`}
                />
              )}
            </StyledMaterialButton>
          );
        }
        return (
          <StyledMaterialButton
            onClick={() => handleFavoriting(onClickFavoriteHandler)}
          >
            <TextWithIcon
              icon={
                isPlaylistFavoritedById
                  ? 'ygb-icon-heart-filled'
                  : 'ygb-icon-heart-outline'
              }
              iconColor={
                isPlaylistFavoritedById
                  ? theme.colors.primary['blue-2']
                  : theme.colors.neutrals.black
              }
              iconSize={'15px'}
              uppercase
            >
              {isPlaylistFavoritedById ? (
                <Trans
                  id="metadata.saved_favorites"
                  message={`Saved to favorites`}
                />
              ) : (
                <Trans
                  id="metadata.save_favorites"
                  message={`Save to favorites`}
                />
              )}
            </TextWithIcon>
          </StyledMaterialButton>
        );
      }}
    </PlaylistFavoriting>
  );
};

export default ButtonFavoritePlaylistCard;
